import React, { useEffect, useContext, useState } from "react";
import PublicAppVars from "utils/PublicAppVars.js";
import {
	levels,
	log,
} from "../utils/Logger.js";

import Toast from "components/Toast.js";
import { TYPE_ERROR } from "components/Banner.js";
import CmsContentList from "components/data/CmsContentList.js";
import CmsContentRenderer from "components/data/CmsContentRenderer.js";


export const TransUnionContext = React.createContext(() => log(null, levels.error, "TransUnionContext used before it was ready"));
export const useTransUnionContext = () => useContext(TransUnionContext);

export const TransUnionProvider = ({ children }) => {
	const [ fingerprint, setFingerprint ] = useState(null);

	useEffect(() => {
		// For some reason Edge & Safari don't play nice with the types on useRef so we will grab the element the old skool way.
		const myInput = document.getElementById(PublicAppVars.TRANS_UNION_BLACKBOX_ELEMENT_ID);

		// Bail out if we don't have an element
		if (!myInput) {
			return;
		}

		const updateValue = () => setFingerprint(myInput.value);

		// Set the value once we have it
		updateValue();

		// If this input changes dynamically, listen for it
		const observer = new MutationObserver(updateValue);
		observer.observe(myInput, { attributes: true, attributeFilter: [ "value" ] });

		return () => observer.disconnect();
	}, [ ]);

	return (
		<TransUnionContext.Provider value={fingerprint}>
			<>
				{PublicAppVars.TRANS_UNION_BLACKBOX_ENABLED &&
					<input
						type="hidden"
						name={PublicAppVars.TRANS_UNION_BLACKBOX_ELEMENT_ID}
						id={PublicAppVars.TRANS_UNION_BLACKBOX_ELEMENT_ID}
					/>
				}
				{children}
			</>
		</TransUnionContext.Provider>
	);
};

export default TransUnionProvider;


// Although this is not context specific let's keep all of the fraud code in one place.
const cms = {
	header: 'miscText.fraud-detection-error-header',
	desc: 'miscText.fraud-detection-error-desc',
};

export const setFraudDetectionAdBlockerToast = (setToast, removeToast) =>
	setToast(
		<CmsContentList list={Object.values(cms)}>{() =>
			<Toast
				type={TYPE_ERROR}
				timeout={0}
				onClosed={removeToast}
				title={
					<CmsContentRenderer
						contentKey={cms.header}
						fallbackValue="We’ve encountered an error"
					/>
				}
				text={
					<CmsContentRenderer
						contentKey={cms.desc}
						fallbackValue="An ad blocker may be interfering with our fraud detection system. Please try again with the ad blocker disabled."
					/>
				}
			/>
		}</CmsContentList>
	);
